import { TDeviceType } from '@cian/ui-kit';
import React, { ReactNode } from 'react';
import cn from 'classnames';

import * as styles from './styles.css';

export const DealStepsGrid: React.FC<{ steps: ReactNode[]; deviceType: TDeviceType }> = props => {
  return (
    <ol className={cn(styles['list'], styles[props.deviceType])}>
      {props.steps.map((item, i) => (
        <li key={i} className={cn(styles['item'], styles[props.deviceType])}>
          {item}
        </li>
      ))}
    </ol>
  );
};
